import RoomsIndex from './RoomsIndex';

export default RoomsIndex;
